import {Pipe, PipeTransform} from '@angular/core';
import {ProjectFile} from '../api';

@Pipe({
  name: 'fileType'
})
export class FileTypePipe implements PipeTransform {

  transform(value: ProjectFile.FileTypeEnum | undefined | string): string {
    switch (value) {
      case ProjectFile.FileTypeEnum.FOLDER: return "Ordner";
      case ProjectFile.FileTypeEnum.PDF: return "PDF";
      case ProjectFile.FileTypeEnum.IFC: return "IFC";
      case ProjectFile.FileTypeEnum.EXCEL: return "XLSX";
      case ProjectFile.FileTypeEnum.POWERPOINT: return "PPTX";
      case ProjectFile.FileTypeEnum.WORD: return "DOCX";
      case ProjectFile.FileTypeEnum.COORDINATION:
        return "Koordinationsmodell";
      case ProjectFile.FileTypeEnum.UNKNOWN: return "Unbekannt";
      default: return value ?? "";
    }
  }
}

/**
 * Einzige Quelle fuer die Beschriftung eines Datei-Status.
 *
 * Vorher gab es drei: dieses Mapping (mit PROCESSING und UPLOADING vertauscht - "Am Hochladen"
 * fuer die laufende Analyse und "Analysiert" fuer den laufenden Upload), die hartcodierten
 * Tooltips der Status-Kreise in files.component.html und die Filter-Labels. Hover und
 * Detailpanel widersprachen sich dadurch fuer dieselbe Zeile.
 */
export const FILE_STATUS_LABELS: Readonly<Record<string, string>> = {
  [ProjectFile.FileStatusEnum.UPLOADING]: "Wird hochgeladen",
  // Bytes sind durch, die Verarbeitung wartet noch - fuer den Nutzer dasselbe Bild wie eine
  // laufende Analyse, deshalb dieselbe Sprache. Der Unterschied ist rein technisch.
  [ProjectFile.FileStatusEnum.UPLOADED]: "Analyse läuft",
  [ProjectFile.FileStatusEnum.PROCESSING]: "Analyse läuft",
  [ProjectFile.FileStatusEnum.READY]: "Bereit",
  [ProjectFile.FileStatusEnum.CHECKED]: "Im Check",
  [ProjectFile.FileStatusEnum.ERROR]: "Klassifizierung fehlgeschlagen",
};

@Pipe({
  name: 'fileStatus'
})
export class FileStatusPipe implements PipeTransform {

  transform(value: ProjectFile.FileStatusEnum | undefined | string): string {
    if (value == null) return "";
    return FILE_STATUS_LABELS[value] ?? value;
  }
}
